/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import { Grid, Tooltip, Box, Stack, Button, Modal } from '@mui/material';
import { Rnd } from 'react-rnd';
import { TextareaAutosize } from '@mui/base';

import './projectInfo.scss';
import { closeIconBlack, pi_veolia_logo } from '../../shared/assets/images';

import { defaultModalOptions } from '../../shared/constantVariable';
import Notification from '../../shared/notification-modal';

/* eslint-disable */
// https://stackoverflow.com/questions/1091372/getting-the-clients-time-zone-and-offset-in-javascript

function getTimeZone() {
  // set up formatter
  let formatter = new Intl.DateTimeFormat(undefined, {
    timeZoneName: 'long'
  });
  // run formatter on current date
  return formatter.formatToParts(Date.now())
    // extract the actual value from the formatter, only reliable way i can find to do this
    .find(formatted => formatted.type === "timeZoneName")['value'].split(' ').map(word => word[0]).join('');
}

export const getCurrentDate = (sec='') => {
  let today = new Date();
  const yyyy = today.getFullYear();
  let mm = today.getMonth() + 1; // Months start at 0!
  let dd = today.getDate();
  let hr = today.getHours();
  let mn = today.getMinutes();
  let ss = today.getSeconds();
  if (dd < 10) dd = '0' + dd;
  if (mm < 10) mm = '0' + mm;
  if (hr < 10) hr = '0' + hr;
  if (mn < 10) mn = '0' + mn;

  if(sec === '-')
    today = `${dd}-${mm}-${yyyy} (${hr}:${mn} ${getTimeZone()})` 
  else{
    sec ? 
    today = `${dd}/${mm}/${yyyy} (${hr}:${mn}:${ss} ${getTimeZone()})` :
    today = `${dd}/${mm}/${yyyy} (${hr}:${mn} ${getTimeZone()})` 
  }
  return today;
};
/* eslint-enable */

const ProjectInfo = (props) => {
  const {
    visiblePi,
    handleClosePi,
    translateObject
  } = props;

  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const [, setProjectInfo] = useState({});
  const [notes, setNotes] = useState('');

  const [contactInfo, setContactInfo] = useState({
    project_name: '',
    location: '',
    engineer: sessionStorage.getItem('user_name'),
    email: sessionStorage.getItem('user_email'),
    contact_no: '',

    filename: '',
    created_on: '',
    last_edited_on: '',
    createdby: sessionStorage.getItem('user_name'),
    sharedby: '',
    isRead: ''
  });
  const [, setIsShowErrorMessage] = useState(false);

  const handleClosePIandSavePInfo = () => {
    handleClosePi();
  };

  const [errors, setErrors] = useState({ // to validate each cell
    project_name: false,
    location: false,
    engineer: false,
    email: false,    // currently email is only used
    contact_no: false
  });

  const validateEmail = () => {
    setIsShowErrorMessage(true);
    const mailFormat = /\S+@\S+\.\S+/;
    if ((String(contactInfo.email)).match(mailFormat) || contactInfo.email.trim().length === 0) {
      setErrors({
        ...errors,
        email: false
      });
    }
    else {
      setErrors({
        ...errors,
        email: true
      });
    }
  };
  const validatevalue = () => {
    setIsShowErrorMessage(true);
  };
  const validateProjectInfoForm = () => {
    let created_on;
    if (localStorage.getItem('project_info')) { // eslint-disable-next-line
      created_on = JSON.parse(localStorage.getItem('project_info')).created_on;
    }
    else
      created_on = getCurrentDate();

    setContactInfo({
      ...contactInfo,
      project_name: (contactInfo.project_name).trim(),
      location: (contactInfo.location).trim(),
      engineer: (contactInfo.engineer).trim(),
      email: (contactInfo.email).trim(),
      contact_no: (contactInfo.contact_no).trim(),
    });

    if (contactInfo.project_name === '') {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        title: 'Warning',
        message: translateObject('Project Name must not be empty'),
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
    }
    else if (errors.email) { // true
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        title: 'Warning',
        message: translateObject('Enter valid Email Id'),
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
    } else { // eslint-disable-next-line
      const locprojectInfo = { ...contactInfo, notes, created_on, last_edited_on: getCurrentDate() };
      setProjectInfo(locprojectInfo);
      localStorage.setItem('project_info', JSON.stringify(locprojectInfo));
      handleClosePIandSavePInfo();
    }
  };

  useEffect(async () => {
    const savedProjectInfo = JSON.parse(localStorage.getItem('project_info'));
    if (savedProjectInfo != null) {
      setContactInfo({
        ...savedProjectInfo,
        project_name: savedProjectInfo.project_name,
        location: savedProjectInfo.location,
        engineer: savedProjectInfo.engineer,
        email: savedProjectInfo.email,
        contact_no: savedProjectInfo.contact_no,
        created_on: savedProjectInfo.created_on
      });

      setNotes(savedProjectInfo.notes);

      setProjectInfo({ ...contactInfo, notes });
    }
  }, []);

  return (
    <Modal
      hideBackdrop
      open={visiblePi}
      onClose={handleClosePIandSavePInfo}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
      className="projectInfo-modal"
    >
      <Box>
        <Rnd
          default={{
            x: ((window.innerWidth / 2) - ((30 * (window.innerWidth / 100)) / 2)),
            y: ((window.innerHeight / 2) - ((50 * (window.innerHeight / 100)) / 2)),
            width: '35%',
          }}
          enableResizing={{
            bottom: false, bottomLeft: false, bottomRight: false,
            left: true, right: true,
            top: false, topLeft: false, topRight: false
          }}
          allowAnyClick
          enableUserSelectHack={false}
          resizeHandleStyles={{ 'right': { 'width': '5px' } }} // reducing width of right handle to 5px ---> kranthi
          cancel='.no_drag'
          minWidth='20%'
          className='projectInfo-box'>
          <Notification
            options={modalOption}
            handleClose={() => setModalOption(defaultModalOptions)}
          />
          <Grid container className='projectInfo-grid-container'>
            <Grid item xs={12} className='projectInfo-header-grid'>
              <div className='projectInfo-header-text ft rufusBld no_drag S_heading forground-text-primary'>
                {translateObject('Project Info')}
              </div>
              <div className='projectInfo-close-icon no_drag'>
                <Tooltip title="Close">
                  <img
                    src={closeIconBlack}
                    alt="close"
                    onClick={handleClosePIandSavePInfo}
                    style={{ display: 'block' }}
                    className="pointer"
                  />
                </Tooltip>
              </div>
            </Grid>
            <Grid item xs={12} className='projectInfo-body-container sansW4SeLig'>
              <Grid container item xs={12} className='container_All' style={{ 'marginTop': '10px' }}>
                <Grid item xs={4} className='project_info_feildname'>
                  <span className="pinfoFeild mt-2 no_drag S_Bold forground-text-primary">{translateObject('Project Name*')}</span>
                </Grid>
                <Grid item xs={8} className='project_info_feildvalue no_drag'>
                  <input
                    autoFocus
                    id="outlined-basic-co2"
                    variant="outlined"
                    className="Form_Input_design pi-input-props"
                    name="pname"
                    onChange={(e) => setContactInfo({ ...contactInfo, project_name: e.target.value })}
                    onBlur={validatevalue}
                    value={contactInfo.project_name}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={12} className='container_All '>
                <Grid item xs={4} className='project_info_feildname'>
                  <span className="pinfoFeild mt-2 no_drag S_Bold forground-text-primary">{translateObject('Location')}</span>
                </Grid>
                <Grid item xs={8} className='project_info_feildvalue no_drag'>
                  <input
                    id="outlined-basic-h2s"
                    variant="outlined"
                    className="Form_Input_design pi-input-props"
                    name="loc"
                    onChange={(e) => setContactInfo({ ...contactInfo, location: e.target.value })}
                    onBlur={validatevalue}
                    value={contactInfo.location}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={12} className='container_All'>
                <Grid item xs={4} className='project_info_feildname'>
                  <span className="pinfoFeild mt-2 no_drag S_Bold forground-text-primary">{translateObject('Engineer')}</span>
                </Grid>
                <Grid item xs={8} className='project_info_feildvalue no_drag'>
                  <input
                    id="outlined-basic-nh3"
                    variant="outlined"
                    className="Form_Input_design pi-input-props"
                    name="engg"
                    onBlur={validatevalue}
                    onChange={(e) => setContactInfo({ ...contactInfo, engineer: e.target.value })}
                    value={contactInfo.engineer}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={12} className='container_All '>
                <Grid item xs={4} className='project_info_feildname'>
                  <span className="pinfoFeild mt-2 no_drag S_Bold forground-text-primary">{translateObject('Email')}</span>
                </Grid>
                <Grid item xs={8} className='project_info_feildvalue no_drag'>
                  <input
                    id="outlined-basic-email"
                    variant="outlined"
                    className={errors.email ? 'Form_Input_design_Error pi-input-props' : 'Form_Input_design pi-input-props'}
                    name="email"
                    onBlur={validateEmail}
                    onChange={(e) => setContactInfo({ ...contactInfo, email: e.target.value })}
                    value={contactInfo.email}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={12} className='container_All '>
                <Grid item xs={4} className='project_info_feildname'>
                  <span className="pinfoFeild mt-2 no_drag S_Bold forground-text-primary">{translateObject('Phone')}</span>
                </Grid>
                <Grid item xs={8} className='project_info_feildvalue no_drag'>
                  <input
                    id="outlined-basic-nh3"
                    variant="outlined"
                    className="Form_Input_design pi-input-props"
                    type="number"
                    name="tel"
                    onChange={(e) => setContactInfo({ ...contactInfo, contact_no: e.target.value })}
                    onBlur={validatevalue}
                    value={contactInfo.contact_no}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={12} className='container_All '>
                <Grid item xs={12} className='project_info_feildvalue no_drag'>
                  <TextareaAutosize
                    aria-label="minimum height"
                    placeholder={translateObject('Enter Notes here...')}
                    style={{ height: '85px' }}
                    className='pi_input_notes'
                    onChange={(e) => setNotes(e.target.value)}
                    onBlur={validatevalue}
                    value={notes}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={12} className='container_All'>
                <Grid item xs={6} style={{ 'display': 'flex', 'alignItems': 'center' }}>
                  <img
                    src={pi_veolia_logo}
                    alt="PI_veolia_logo"
                    style={{ display: 'block', 'margin': '16px' }}
                    className="v_pi_logo no_drag"
                  />
                </Grid>
                <Grid item xs={6} className='projectInfo-body-container sansW4SeLig projectInfo-ok-button no_drag'>
                  <Stack spacing={2} direction="row" sx={{ 'm': 2, 'justifyContent': 'center' }}>
                    <Button style={{ width: '120px', height: '32px', borderRadius: '4px' }}
                      className="stripper-btn btn sansW4SeLig M_Bold Primary_Default_Button"
                      variant="contained" onClick={validateProjectInfoForm}
                    >{translateObject('Ok')}</Button>
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Rnd>
      </Box>
    </Modal>
  );
};

export default ProjectInfo;
